"use client";
import "../chunk-N3ETBM74.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { msalAuthSettings } from "../msal";
import { stashPostLoginTarget } from "../postLoginTarget";
const CreateAccountButton = ({ explainer, text, locale }) => {
  const { inProgress, instance } = useMsal();
  const handleCreateAccount = async () => {
    if (inProgress !== InteractionStatus.None) return;
    const redirect = `${window.location.pathname}${window.location.search}`;
    stashPostLoginTarget(redirect);
    await instance.loginRedirect({
      redirectUri: msalAuthSettings.config.auth.redirectUri,
      extraQueryParameters: { flowState: "signup", ui_locales: locale },
      scopes: msalAuthSettings.scopes
    });
  };
  return /* @__PURE__ */ jsxs("div", { className: "gap-semantic-global-xs flex flex-col", children: [
    /* @__PURE__ */ jsx("span", { className: "font-primitive-dfds-sans font-primitive-regular tracking-primitive-0 align-middle text-pretty text-primitive-14 leading-primitive-20 md:text-primitive-14 md:leading-primitive-20 lg:text-primitive-14 lg:leading-primitive-20", children: explainer }),
    /* @__PURE__ */ jsx("div", { className: "w-full", "data-e2e-create-account": true, children: /* @__PURE__ */ jsx(
      "button",
      {
        className: "font-primitive-dfds-sans font-primitive-medium tracking-primitive-0 align-middle text-pretty text-primitive-14 leading-primitive-20 md:text-primitive-14 md:leading-primitive-20 lg:text-primitive-14 lg:leading-primitive-20 border-semantic-global-primary-darkest text-semantic-global-text-default hover:bg-semantic-form-controls-background-ghost-hover active:bg-semantic-form-controls-background-ghost-pressed flex h-10 w-full cursor-pointer items-center justify-center border border-solid bg-transparent",
        disabled: inProgress !== InteractionStatus.None,
        onClick: handleCreateAccount,
        type: "button",
        children: text
      }
    ) })
  ] });
};
var CreateAccountButton_default = CreateAccountButton;
export {
  CreateAccountButton_default as default
};
